import styled from "styled-components";

const Box = styled.div`
  max-width: 600px;
  color: var(--color-text-primary);
  background-color: var(--color-bg-sidebar);
  border-radius: 4px;
  padding: 10px;
  font-size: 12px;
  border: 1px solid var(--color-text-secondary);
  align-self: flex-start;
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
`;
const Col = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
`;

const Label = styled.span`
  font-weight: bold;
  color: var(--color-text-secondary);
`;

const Info = styled.p`
  line-height: 1.4;
  position: relative;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const PriorityInfo = ({
  taskId,
  status,
  orgFeatures = [],
  organization,
  hoursWorked,
  hoursEstimate,
  recommendationId,
  supportCase,
}) => {
  const unitLabel = orgFeatures.includes("PRIORITIES_HoursAsPoints") ? "Points" : "Hours";

  return (
    <Box>
      <Row>
        <Label>Task ID</Label>
        <Col>
          <Info>{taskId}</Info>
        </Col>
      </Row>
      <Row>
        <Label>Status</Label>
        <Col>
          <Info>{capitalize(status)}</Info>
        </Col>
      </Row>
      <Row>
        <Label>Organization</Label>
        <Col>
          <Info>{organization}</Info>
        </Col>
      </Row>
      {!orgFeatures.includes("PRIORITIES_HideHoursWorked") && (
        <Row>
          <Label>{unitLabel} Worked</Label>
          <Col>
            <Info>{hoursWorked || "-"}</Info>
          </Col>
        </Row>
      )}
      {!orgFeatures.includes("PRIORITIES_HideHoursEstimated") && (
        <Row>
          <Label>{unitLabel} Estimate</Label>
          <Col>
            <Info>{hoursEstimate || "-"}</Info>
          </Col>
        </Row>
      )}
      { recommendationId && (
        <Row>
          <Label>Recommendation</Label>
          <Col>
            <Info>{recommendationId}</Info>
          </Col>
        </Row>
      )}
      { supportCase && (
        <Row>
          <Label>Support Case</Label>
          <Col>
            <Info>{supportCase}</Info>
          </Col>
        </Row>
      )}
    </Box>
  );
};

function capitalize(str) {
  if (!str) return;

  return str
    .split(/(?=[A-Z])/)
    .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export default PriorityInfo;
